export default "__VITE_ASSET__0wDS$cfG__"